import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-alert-component',
  templateUrl: './alert-component.component.html',
  styleUrls: ['./alert-component.component.scss']
})
export class AlertComponentComponent implements OnInit {
  timeout: number;
  autoClose: boolean;

  constructor(
    public dialogRef: MatDialogRef<AlertComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.timeout = 3000;
  }

  ngOnInit() {
    if (this.data) {
      if (this.data.buttons && this.data.buttons.length > 0) {
        this.autoClose = true;
        for (let index = 0; index < this.data.buttons.length; index++) {
          const element = this.data.buttons[index];
          if (element.close) {
            this.autoClose = false;
            break;
          }
        }
      } else {
        this.autoClose = true;
        if (this.data.timeout) {
          this.timeout = this.data.timeout;
        }
      }
      if (this.data.forceAutoClose) {
        this.autoClose = true;
      }
    }

    if (this.autoClose) {
      setTimeout(() => {
        this.dialogRef.close();
      }, this.timeout);
    }
  }

  onButtonClick(item) {
    if (!item) {
      return;
    }
    let value = null;
    if (item.value) {
      value = item.value;
    }
    if (item.callback) {
      item.callback(value);
    }
    if (item.close) {
      this.dialogRef.close(value);
    }
  }

}
